exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".start-reset-toggle[data-v-f26d91f0] {\n  text-decoration: underline;\n}\n.start-form-toggle[data-v-f26d91f0] {\n  display: block;\n  padding: 1rem 0 0 0.5rem;\n}\n@media (min-width: 500px) {\n.start-form-toggle[data-v-f26d91f0] {\n    float: right;\n    padding: 0.9rem 0;\n}\n}", ""]);

// exports
